import { useQueryClient } from 'react-query';

import { useTranslation } from 'common/hooks/useTranslation';
import { useNotifications } from 'modules/app/notifications';
import { deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues } from 'src/client/spendesk-api';

import { useCompanyId } from '../../app/hooks/useCompanyId';

type CustomFieldValuesDeletePayload = {
  customFieldId: string;
  customFieldValueIds: string[];
};

export const useDeleteCustomFieldValuesMutation = (): ((
  params: CustomFieldValuesDeletePayload,
) => Promise<void>) => {
  const companyId = useCompanyId();
  const { t } = useTranslation('global');
  const { successNotif, dangerNotif } = useNotifications();
  const queryClient = useQueryClient();

  return async (params: CustomFieldValuesDeletePayload) => {
    try {
      const response =
        await deleteV2ApiCompanyIdCustomFieldsCustomFieldIdValues({
          path: {
            companyId,
            customFieldId: params.customFieldId,
          },
          body: {
            valueIds: params.customFieldValueIds,
          },
        });

      if (response.statusCode !== 204) {
        throw new Error('Failed to delete custom field values', {
          cause: response.body,
        });
      }

      queryClient.invalidateQueries([
        'useCustomFieldValuesQuery',
        params.customFieldId,
      ]);

      successNotif(t('customFields.settings.modals.deletion.success'));
    } catch (error) {
      dangerNotif(t('customFields.settings.modals.deletion.error'));
      throw error;
    }
  };
};
